import { render, staticRenderFns } from "./DashboardMonitoring.vue?vue&type=template&id=2f5dc638&scoped=true&"
import script from "./DashboardMonitoring.vue?vue&type=script&lang=js&"
export * from "./DashboardMonitoring.vue?vue&type=script&lang=js&"
import style0 from "./DashboardMonitoring.vue?vue&type=style&index=0&id=2f5dc638&prod&scoped=true&lang=css&"
import style1 from "./DashboardMonitoring.scss?vue&type=style&index=1&id=2f5dc638&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5dc638",
  null
  
)

export default component.exports